module.exports = __webpack_public_path__ + "static/logo_dark-74e1dab06ab1f95bb1a8704853cf33a9.png";